"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _ScrollableStack = _interopRequireDefault(require("@commerce-ui/core2/ScrollableStack"));
var _useWindowSize = _interopRequireDefault(require("@commerce-ui/core2/useWindowSize"));
var _Category = _interopRequireDefault(require("@deosite/ui-entities/Category"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CategoriesTagsSlider = function CategoriesTagsSlider(_ref) {
  var categories = _ref.categories,
    button = _ref.button;
  var tagButton = function tagButton(label) {
    return /*#__PURE__*/_react["default"].cloneElement(button, {
      sx: {
        $outline: true,
        $size: "small",
        $rounded: true,
        $selectable: true,
        mx: "s3",
        mb: "s4",
        width: ["40vw", "130px", "150px", "auto"],
        maxWidth: ["40vw", "130px", "150px", "unset"],
        "&:hover": {
          borderColor: "main"
        }
      }
    }, label);
  };
  var size = (0, _useWindowSize["default"])();
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var containerStyles = {
    width: "100%",
    maxWidth: "100%",
    my: "s10",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
  if (size.width <= 960) return __jsx(_ScrollableStack["default"], {
    sx: _objectSpread(_objectSpread({}, containerStyles), {}, {
      $itemsVisible: [2.1, 3.5, 4.1, null],
      $gap: 4
    })
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
    return __jsx(Link, {
      route: "category-page",
      params: category
    }, tagButton(category.name));
  }));else return __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, containerStyles), {}, {
      flexWrap: "wrap"
    })
  }, categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
    return __jsx(Link, {
      route: "category-page",
      params: category
    }, tagButton(category.name));
  }));
};
var _default = CategoriesTagsSlider;
exports["default"] = _default;